import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
// import Setting from "@/views/Setting";
import Update from "@/views/Update";
import Satisfaction from "@/views/Satisfaction";
import Tips from "@/views/Tips";
import Apps from "@/views/Apps";
import VueMeta from 'vue-meta'

Vue.use(Router)
Vue.use(VueMeta)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/webs',
      name: 'home',
      component: Home
    },
    {
      path: '/webs/update',
      name: 'update',
      component: Update
    },
    {
      path: '/webs/satisfaction',
      name: 'satisfaction',
      component: Satisfaction
    },
    {
      path: '/webs/tips',
      name: 'tips',
      component: Tips
    },
    {
      path: '/webs/apps',
      name: 'apps',
      component: Apps
    },
    {
      path: '*',
      redirect: {
        path: '/webs',
        name: 'home'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// router.beforeEach((to, from, next) => {
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js